
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SalesFilterState } from "app/types/service-types/SalesTypes";
import DateUtils from "app/utils/DateUtils";

const todayIso = DateUtils.convertDateToIso(new Date()); // YYYY-MM-DD

const initialState: SalesFilterState = {
  fromDate: todayIso,
  toDate: todayIso,
  isPaid: true,
  // isRefund: true,
  source: "BMT_NETWORK",
  sort: "createdDate,desc",
};

const internalFilterSalesSlice = createSlice({
  name: "internalSales/filter",
  initialState,
  reducers: {
    setInternalSalesFilters(state, action: PayloadAction<Partial<SalesFilterState>>) {
      return { ...state, ...action.payload };
    },
    clearInternalSalesFilters() {
      return initialState;
    },
  },
});

export const { setInternalSalesFilters, clearInternalSalesFilters } = internalFilterSalesSlice.actions;
export default internalFilterSalesSlice.reducer;
